// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/inter/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/inter/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/inter/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/inter/Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/inter/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/inter/Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/inter/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/inter/Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/open-sans/OpenSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/fonts/lato/Lato-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/fonts/montserrat/Montserrat-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/fonts/poppins/Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/fonts/nunito/Nunito-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/fonts/raleway/Raleway-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/fonts/source-sans-3/SourceSans3-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/fonts/playfair-display/PlayfairDisplay-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-display: swap;
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-display: swap;
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-display: swap;
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("ttf");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("ttf");
  font-display: swap;
  font-weight: 500;
  font-style: normal;
}

/* Roboto doesnt have a direct 600 font-weight option */
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("ttf");
  font-display: swap;
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("ttf");
  font-display: swap;
  font-weight: 700;
  font-style: normal;
}

/* Open Sans */
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Lato */
@font-face {
  font-family: "Lato";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Montserrat */
@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Poppins */
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Nunito */
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Raleway */
@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Source Sans 3 */
@font-face {
  font-family: "Source Sans 3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

/* Playfair Display */
@font-face {
  font-family: "Playfair Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/flow/fonts.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;0DACgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DAC+D;EAC/D,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DACiE;EACjE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DAC6D;EAC7D,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0DAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0DAAkE;EAClE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,0DAAkE;EAClE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2DAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,wBAAwB;EACxB,6DAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,6DAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,6DAA+E;EAC/E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,6DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,6DAAuE;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,6DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,6DAAmF;EACnF,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,+BAA+B;EAC/B,6DAA0F;EAC1F,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  src: url(\"../assets/fonts/inter/Inter-Regular.woff2\") format(\"woff2\"),\n    url(\"../assets/fonts/inter/Inter-Regular.woff\") format(\"woff\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src: url(\"../assets/fonts/inter/Inter-Medium.woff2\") format(\"woff2\"),\n    url(\"../assets/fonts/inter/Inter-Medium.woff\") format(\"woff\");\n  font-display: swap;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src: url(\"../assets/fonts/inter/Inter-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../assets/fonts/inter/Inter-SemiBold.woff\") format(\"woff\");\n  font-display: swap;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src: url(\"../assets/fonts/inter/Inter-Bold.woff2\") format(\"woff2\"),\n    url(\"../assets/fonts/inter/Inter-Bold.woff\") format(\"woff\");\n  font-display: swap;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto/Roboto-Regular.ttf\") format(\"ttf\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto/Roboto-Medium.ttf\") format(\"ttf\");\n  font-display: swap;\n  font-weight: 500;\n  font-style: normal;\n}\n\n/* Roboto doesnt have a direct 600 font-weight option */\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto/Roboto-Medium.ttf\") format(\"ttf\");\n  font-display: swap;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto/Roboto-Bold.ttf\") format(\"ttf\");\n  font-display: swap;\n  font-weight: 700;\n  font-style: normal;\n}\n\n/* Open Sans */\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../assets/fonts/open-sans/OpenSans-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Lato */\n@font-face {\n  font-family: \"Lato\";\n  src: url(\"../assets/fonts/lato/Lato-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Montserrat */\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"../assets/fonts/montserrat/Montserrat-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Poppins */\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"../assets/fonts/poppins/Poppins-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Nunito */\n@font-face {\n  font-family: \"Nunito\";\n  src: url(\"../assets/fonts/nunito/Nunito-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Raleway */\n@font-face {\n  font-family: \"Raleway\";\n  src: url(\"../assets/fonts/raleway/Raleway-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Source Sans 3 */\n@font-face {\n  font-family: \"Source Sans 3\";\n  src: url(\"../assets/fonts/source-sans-3/SourceSans3-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Playfair Display */\n@font-face {\n  font-family: \"Playfair Display\";\n  src: url(\"../assets/fonts/playfair-display/PlayfairDisplay-Regular.woff2\") format(\"woff2\");\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
